import { useTranslation } from 'react-i18next'
import { useScrollReveal } from '@/hooks/use-scroll-reveal'
import Container from '@/components/ui/container'
import Link from '@/components/ui/link'
import LinkCta from '@/components/ui/link-cta'
import SectionHeader from '@/components/ui/section-header'

const caseImages = [
  {
    image: 'https://bravic-public-prod.s3.us-east-2.amazonaws.com/case-scoder.png',
    alt: 'Scoder Case',
  },
  {
    image: 'https://bravic-public-prod.s3.us-east-2.amazonaws.com/case-jhsf.png',
    alt: 'JHSF Case',
  },
  {
    image:
      'https://lh3.googleusercontent.com/aida-public/AB6AXuA_B_C_D_E_F_G_H_I_J_K_L_M_N_O_P_Q_R_S_T_U_V_W_X_Y_Z',
    alt: 'Linhas arquitetônicas de server farm moderno',
  },
]

export default function Cases() {
  const { t } = useTranslation()
  const { ref, visible } = useScrollReveal()

  const cases = t('cases.items', { returnObjects: true }) as {
    category: string
    title: string
    description: string
    href: string
  }[]

  return (
    <section ref={ref} id="cases" className="py-16 md:py-24 lg:py-32 bg-surface-container-lowest">
      <Container>
        <div
          className={`transition-all duration-700 ease-out ${
            visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <SectionHeader
            label={t('cases.label')}
            heading={t('cases.heading')}
            description={t('cases.description')}
            className="mb-10 md:mb-16 lg:mb-20"
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {cases.map((caseItem, i) => (
            <Link
              key={i}
              href={caseItem.href}
              className={`group relative aspect-4/5 overflow-hidden bg-black flex flex-col justify-end p-5 md:p-8 transition-all duration-700 ease-out ${
                visible
                  ? 'opacity-100 translate-y-0 scale-100'
                  : 'opacity-0 translate-y-10 scale-95'
              }`}
              style={{ transitionDelay: visible ? `${300 + i * 150}ms` : '0ms' }}
            >
              <img
                className="absolute inset-0 w-full object-cover opacity-40case-jh group-hover:scale-110 transition-transform duration-1000"
                src={caseImages[i]?.image}
                alt={caseImages[i]?.alt}
              />
              <div className="absolute inset-0 bg-linear-to-t from-surface via-surface/20 to-transparent" />
              <div className="relative z-10">
                <span className="text-primary font-body text-[0.65rem] uppercase tracking-[0.3em] font-bold mb-3 block">
                  {caseItem.category}
                </span>
                <h3 className="font-display text-2xl font-bold mb-4 text-white leading-tight">
                  {caseItem.title}
                </h3>
                <p className="text-on-surface-variant text-sm mb-6 line-clamp-2 opacity-80 group-hover:opacity-100 transition-opacity">
                  {caseItem.description}
                </p>
                <LinkCta className="text-primary-container">{t('cases.viewCase')}</LinkCta>
              </div>
            </Link>
          ))}
        </div>
      </Container>
    </section>
  )
}
